"use client"

import { useCallback, useState } from "react"
import { useTranslations } from "next-intl"
import { UnifiedAddToCartButton } from "@/components/UnifiedAddToCartButton"
import AuthModal from "@/components/ui/auth-modal"
import { OfferModal } from "./offer-modal"
import type { ComponentProps } from "react"

type UnifiedOmit = Omit<ComponentProps<typeof UnifiedAddToCartButton>, "splitCommerce">

type OfferConfig = {
  listingId: string
  currentUserId: string | null
  listingPrice: number | null
  currency: string | null
  listingTitle?: string
  listingImageUrl?: string | null
  onSuccess?: (offerId: string) => void
}

export function ListingSplitCommerceCta({
  unified,
  offer,
}: {
  unified: UnifiedOmit
  offer: OfferConfig
}) {
  const t = useTranslations()
  const [offerOpen, setOfferOpen] = useState(false)
  const [authOpen, setAuthOpen] = useState(false)

  const handleOfferSelect = useCallback(() => {
    if (!offer.currentUserId) {
      setAuthOpen(true)
      return
    }
    setOfferOpen(true)
  }, [offer.currentUserId])

  return (
    <>
      <UnifiedAddToCartButton
        {...unified}
        splitCommerce={{
          mode: "cart",
          onModeChange: (m) => {
            if (m === "offer") handleOfferSelect()
          },
        }}
      />
      <OfferModal
        open={offerOpen}
        onOpenChange={setOfferOpen}
        mode={{
          kind: "create",
          listingId: offer.listingId,
          listingPrice: offer.listingPrice,
          currency: offer.currency,
        }}
        listingPreview={
          offer.listingTitle
            ? { title: offer.listingTitle, imageUrl: offer.listingImageUrl ?? null }
            : undefined
        }
        onSuccess={offer.onSuccess}
      />
      <AuthModal
        isOpen={authOpen}
        onCloseAction={() => setAuthOpen(false)}
        message={t("offers.authPrompt", {
          default: "Please log in or register to make an offer.",
        })}
      />
    </>
  )
}
